var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cfde-explore" }, [
    _vm.showUrlChoiceDialog
      ? _c("div", { staticClass: "url-choice-dialog-overlay" }, [
          _c("div", { staticClass: "url-choice-dialog" }, [
            _vm._m(0),
            _c("div", { staticClass: "url-choice-options" }, [
              _c("div", { staticClass: "url-choice-option" }, [
                _vm._m(1),
                _c("div", { staticClass: "url-choice-preview" }, [
                  _c("strong", [_vm._v("Associations data:")]),
                  _c("pre", [
                    _vm._v(_vm._s(_vm.urlChoiceOptions.associations)),
                  ]),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary url-choice-btn",
                    on: { click: _vm.chooseAssociations },
                  },
                  [_vm._v(" Use Associations ")]
                ),
              ]),
              _c("div", { staticClass: "url-choice-option" }, [
                _vm._m(2),
                _c("div", { staticClass: "url-choice-preview" }, [
                  _c("strong", [_vm._v("Genes:")]),
                  _c("span", { staticClass: "genes-list" }, [
                    _vm._v(_vm._s(_vm.urlChoiceOptions.genes.join(", "))),
                  ]),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary url-choice-btn",
                    on: { click: _vm.chooseGenes },
                  },
                  [_vm._v(" Use Genes ")]
                ),
              ]),
            ]),
            _c("div", { staticClass: "url-choice-actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  on: { click: _vm.cancelUrlChoice },
                },
                [_vm._v(" Cancel ")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "upper-layout" }, [
      _c("div", { staticClass: "left-column" }, [
        _c("div", { staticClass: "gene-sets-input" }, [
          !_vm.hideAssociationsInput
            ? _c("div", [
                _c("small", { staticClass: "input-warning" }, [
                  _vm._v(
                    "Load genes from phenotype-gene set associations or enter genes manually to Genes input below"
                  ),
                ]),
                _vm._m(3),
                _c("small", { staticClass: "format-suggestion" }, [
                  _vm._v(
                    "Format data with comma-separated columns: Phenotype, Gene set, Source"
                  ),
                ]),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.geneSets,
                      expression: "geneSets",
                    },
                  ],
                  staticClass: "gene-sets-field",
                  attrs: {
                    id: "gene-sets",
                    placeholder:
                      "e.g., rare inborn errors of metabolism, T69-Brown-Adipose_Male_8W_Down, motrpac",
                    rows: "3",
                  },
                  domProps: { value: _vm.geneSets },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.geneSets = $event.target.value
                    },
                  },
                }),
              ])
            : _vm._e(),
          !_vm.hideAssociationsInput &&
          !_vm.showManualGeneInput &&
          _vm.geneSets.trim() &&
          (_vm.geneData.length === 0 || _vm.associationsModified)
            ? _c("div", { staticClass: "load-genes-section" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary load-genes-btn",
                    attrs: { disabled: _vm.isLoadingGenes },
                    on: { click: _vm.loadGenesFromAssociations },
                  },
                  [
                    _vm.isLoadingGenes
                      ? _c("span", { staticClass: "loading-spinner-small" })
                      : _vm._e(),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isLoadingGenes ? "Loading genes..." : "Load genes"
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("small", { staticClass: "load-genes-hint" }, [
                  _vm._v(
                    "Click to fetch genes from the phenotype-gene set associations above"
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "gene-input-section" }, [
            _vm._m(4),
            (_vm.fetchedGeneData.length > 0 || _vm.geneData.length > 0) &&
            !_vm.hasManualGenes
              ? _c("div", { staticClass: "gene-filter-section" }, [
                  _c("div", { staticClass: "filter-checkboxes-column" }, [
                    _c("div", { staticClass: "overlap-filter" }, [
                      _c("label", { staticClass: "overlap-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showOnlyLogBfGenes,
                              expression: "showOnlyLogBfGenes",
                            },
                          ],
                          staticClass: "overlap-checkbox",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.showOnlyLogBfGenes)
                              ? _vm._i(_vm.showOnlyLogBfGenes, null) > -1
                              : _vm.showOnlyLogBfGenes,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.showOnlyLogBfGenes,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showOnlyLogBfGenes = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showOnlyLogBfGenes = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showOnlyLogBfGenes = $$c
                                }
                              },
                              _vm.updateFilteredGenesAndInput,
                            ],
                          },
                        }),
                        _vm._v(
                          " Filter out " +
                            _vm._s(_vm.genesWithLogBfZero) +
                            " genes with direct genetic support score == 0 "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "overlap-filter" }, [
                      _c(
                        "label",
                        {
                          staticClass: "overlap-checkbox-label",
                          class: {
                            disabled: _vm.shouldDisableOverlappingFilter,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showOnlyOverlappingGenes,
                                expression: "showOnlyOverlappingGenes",
                              },
                            ],
                            staticClass: "overlap-checkbox",
                            attrs: {
                              type: "checkbox",
                              disabled: _vm.shouldDisableOverlappingFilter,
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.showOnlyOverlappingGenes
                              )
                                ? _vm._i(_vm.showOnlyOverlappingGenes, null) >
                                  -1
                                : _vm.showOnlyOverlappingGenes,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.showOnlyOverlappingGenes,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.showOnlyOverlappingGenes =
                                          $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.showOnlyOverlappingGenes = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.showOnlyOverlappingGenes = $$c
                                  }
                                },
                                _vm.updateFilteredGenesAndInput,
                              ],
                            },
                          }),
                          !_vm.shouldDisableOverlappingFilter
                            ? _c("span", [
                                _vm._v(
                                  " Show " +
                                    _vm._s(_vm.overlappingGenesCount) +
                                    " overlapping genes only "
                                ),
                              ])
                            : _c("span", { staticClass: "disabled-text" }, [
                                _vm._v(
                                  " Overlapping genes filter (disabled - only one association or manual genes) "
                                ),
                              ]),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("small", { staticClass: "format-suggestion" }, [
              _vm._v(
                " Enter genes separated by commas (e.g., GENE1, GENE2, GENE3) "
              ),
              _vm.getGeneCountFromInput() > 0
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "8px",
                        "font-weight": "600",
                        color: "#333",
                      },
                    },
                    [
                      _vm._v(
                        " (" +
                          _vm._s(_vm.getGeneCountFromInput()) +
                          " gene" +
                          _vm._s(_vm.getGeneCountFromInput() !== 1 ? "s" : "") +
                          ") "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.manualGenes,
                  expression: "manualGenes",
                },
              ],
              staticClass: "manual-genes-field",
              attrs: {
                id: "manual-genes",
                placeholder: "e.g., TP53, BRCA1, MYC, EGFR",
                rows: "2",
              },
              domProps: { value: _vm.manualGenes },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.manualGenes = $event.target.value
                },
              },
            }),
          ]),
          _vm.manualGenes.trim() && _vm.hasHypothesis
            ? _c(
                "div",
                {
                  staticClass: "gene-utility-section",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("research-gene-set-utility", {
                    ref: "geneSetUtility",
                    attrs: {
                      genes: _vm.parsedGenes,
                      hypothesis: _vm.phenotypeSearch,
                      researchContext: _vm.researchContext,
                      selectedGenes: _vm.selectedGenes,
                      llmConfig: _vm.llmConfig,
                      noveltyScoreBatchSize: _vm.noveltyScoreBatchSize,
                      hideButtons: true,
                    },
                    on: { "update:selectedGenes": _vm.handleGenesSelected },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "gene-sets-input" }, [
          _c("div", { staticClass: "section-header" }, [
            _c("h4", [
              _vm._v(
                " Hypothesis (Optional - Required for Gene Prioritization) "
              ),
              _vm.showGenerateHypothesisButton
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm btn-primary generate-hypothesis-btn-inline",
                      attrs: {
                        disabled:
                          _vm.isFetchingPhenotypes ||
                          _vm.isGeneratingHypothesis,
                      },
                      on: { click: _vm.openPhenotypeSelection },
                    },
                    [
                      _vm.isFetchingPhenotypes || _vm.isGeneratingHypothesis
                        ? _c("span", { staticClass: "loading-spinner-small" })
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isFetchingPhenotypes
                              ? "Fetching..."
                              : _vm.isGeneratingHypothesis
                              ? `Generating... (${_vm.hypothesisGenerationElapsedTime})`
                              : "Generate Hypothesis"
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm.hypothesisPhenotypes.length > 0
            ? _c("div", { staticClass: "hypothesis-phenotypes-section" }, [
                _c(
                  "div",
                  {
                    staticClass: "hypothesis-phenotypes-header",
                    on: {
                      click: function ($event) {
                        _vm.showHypothesisPhenotypes =
                          !_vm.showHypothesisPhenotypes
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "collapse-icon" }, [
                      _vm._v(_vm._s(_vm.showHypothesisPhenotypes ? "▼" : "▶")),
                    ]),
                    _c("span", { staticClass: "hypothesis-phenotypes-label" }, [
                      _vm._v("Phenotype / gene sets of interest."),
                    ]),
                    _c("span", { staticClass: "hypothesis-phenotypes-count" }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.hypothesisPhenotypes.length) +
                          " phenotype" +
                          _vm._s(
                            _vm.hypothesisPhenotypes.length !== 1 ? "s" : ""
                          ) +
                          ")"
                      ),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-secondary update-hypothesis-btn",
                        attrs: {
                          disabled:
                            _vm.isFetchingPhenotypes ||
                            _vm.isGeneratingHypothesis,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.openPhenotypeSelection.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v(" Update Hypothesis. ")]
                    ),
                  ]
                ),
                _vm.showHypothesisPhenotypes &&
                _vm.hypothesisPhenotypes.length > 0
                  ? _c(
                      "div",
                      { staticClass: "hypothesis-phenotypes-content" },
                      [
                        _vm.researchContext.trim()
                          ? _c(
                              "div",
                              {
                                staticClass: "research-context-display",
                                staticStyle: {
                                  "margin-bottom": "15px",
                                  padding: "12px",
                                  background: "#f8f9fa",
                                  "border-left": "3px solid #FF6600",
                                  "border-radius": "4px",
                                },
                              },
                              [
                                _c(
                                  "strong",
                                  {
                                    staticStyle: {
                                      color: "#333",
                                      "font-size": "13px",
                                    },
                                  },
                                  [_vm._v("Research Context:")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      margin: "8px 0 0 0",
                                      color: "#666",
                                      "font-size": "13px",
                                      "line-height": "1.5",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.researchContext))]
                                ),
                                _c(
                                  "small",
                                  {
                                    staticStyle: {
                                      color: "#999",
                                      "font-size": "11px",
                                      "font-style": "italic",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "This context was used to generate the hypothesis."
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "table-container" }, [
                          _c(
                            "table",
                            { staticClass: "hypothesis-phenotypes-table" },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(
                                    _vm.getOrderedColumnKeys(
                                      _vm.hypothesisPhenotypes[0]
                                    ),
                                    function (key) {
                                      return _c(
                                        "th",
                                        {
                                          key: key,
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatColumnHeader(key)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.paginatedHypothesisPhenotypes,
                                  function (phenotype, index) {
                                    return _c(
                                      "tr",
                                      { key: index },
                                      _vm._l(
                                        _vm.getOrderedColumnKeys(phenotype),
                                        function (key) {
                                          return _c("td", { key: key }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatCellValue(
                                                    phenotype[key]
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm.hypothesisPhenotypesTotalPages > 1
                          ? _c(
                              "div",
                              {
                                staticClass: "hypothesis-phenotypes-pagination",
                              },
                              [
                                _c("div", { staticClass: "pagination-info" }, [
                                  _vm._v(
                                    " Showing " +
                                      _vm._s(
                                        (_vm.hypothesisPhenotypesPage - 1) *
                                          (_vm.hypothesisPhenotypesItemsPerPage ===
                                          "all"
                                            ? _vm.hypothesisPhenotypes.length
                                            : _vm.hypothesisPhenotypesItemsPerPage) +
                                          1
                                      ) +
                                      " to " +
                                      _vm._s(
                                        Math.min(
                                          _vm.hypothesisPhenotypesPage *
                                            (_vm.hypothesisPhenotypesItemsPerPage ===
                                            "all"
                                              ? _vm.hypothesisPhenotypes.length
                                              : _vm.hypothesisPhenotypesItemsPerPage),
                                          _vm.hypothesisPhenotypes.length
                                        )
                                      ) +
                                      " of " +
                                      _vm._s(_vm.hypothesisPhenotypes.length) +
                                      " entries "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "pagination-controls" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "pagination-btn first-last-btn",
                                        attrs: {
                                          disabled:
                                            _vm.hypothesisPhenotypesPage === 1,
                                          title: "First page",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.hypothesisPhenotypesPage = 1
                                          },
                                        },
                                      },
                                      [_vm._v(" «« ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "pagination-btn",
                                        attrs: {
                                          disabled:
                                            _vm.hypothesisPhenotypesPage === 1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.hypothesisPhenotypesPage--
                                          },
                                        },
                                      },
                                      [_vm._v(" Previous ")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "page-numbers" },
                                      _vm._l(
                                        _vm.getVisiblePages(
                                          _vm.hypothesisPhenotypesPage,
                                          _vm.hypothesisPhenotypesTotalPages
                                        ),
                                        function (page) {
                                          return _c(
                                            "button",
                                            {
                                              key: page,
                                              class: [
                                                "page-btn",
                                                {
                                                  active:
                                                    page ===
                                                    _vm.hypothesisPhenotypesPage,
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  _vm.hypothesisPhenotypesPage =
                                                    page
                                                },
                                              },
                                            },
                                            [_vm._v(" " + _vm._s(page) + " ")]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "pagination-btn",
                                        attrs: {
                                          disabled:
                                            _vm.hypothesisPhenotypesPage ===
                                            _vm.hypothesisPhenotypesTotalPages,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.hypothesisPhenotypesPage++
                                          },
                                        },
                                      },
                                      [_vm._v(" Next ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "pagination-btn first-last-btn",
                                        attrs: {
                                          disabled:
                                            _vm.hypothesisPhenotypesPage ===
                                            _vm.hypothesisPhenotypesTotalPages,
                                          title: "Last page",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.hypothesisPhenotypesPage =
                                              _vm.hypothesisPhenotypesTotalPages
                                          },
                                        },
                                      },
                                      [_vm._v(" »» ")]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("div", { staticClass: "textarea-container" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.phenotypeSearch,
                  expression: "phenotypeSearch",
                },
              ],
              staticClass: "hypothesis-textarea",
              attrs: { placeholder: "Enter your hypothesis...", rows: "3" },
              domProps: { value: _vm.phenotypeSearch },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.phenotypeSearch = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "right-column" }, [
        _c("div", { staticClass: "gene-options-section" }, [
          _c("div", { staticClass: "gene-options-header" }, [
            _c("h4", [_vm._v("Explore Further with your genes")]),
            _c("small", { staticClass: "format-suggestion" }, [
              _vm._v(
                "Choose how you'd like to analyze the genes in your list. Enter genes above to enable the options below" +
                  _vm._s(
                    _vm.hasHypothesis
                      ? ""
                      : " (hypothesis scoring not available without hypothesis parameter)"
                  ) +
                  ":"
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "card-category-filter",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _c(
                "label",
                {
                  staticStyle: {
                    "margin-right": "10px",
                    "font-weight": "500",
                    color: "#333",
                  },
                  attrs: { for: "card-category-select" },
                },
                [_vm._v("Filter by category:")]
              ),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedCardCategory,
                      expression: "selectedCardCategory",
                    },
                  ],
                  staticClass: "form-control",
                  staticStyle: {
                    display: "inline-block",
                    width: "auto",
                    "min-width": "200px",
                    padding: "6px 12px",
                    border: "1px solid #ddd",
                    "border-radius": "4px",
                    "font-size": "14px",
                  },
                  attrs: { id: "card-category-select" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedCardCategory = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "all" } }, [_vm._v("All")]),
                  _c("option", { attrs: { value: "Gene Prioritization" } }, [
                    _vm._v("Gene Prioritization"),
                  ]),
                  _c("option", { attrs: { value: "Expression Analysis" } }, [
                    _vm._v("Expression Analysis"),
                  ]),
                  _c("option", { attrs: { value: "Discovery & Enrichment" } }, [
                    _vm._v("Discovery & Enrichment"),
                  ]),
                  _c("option", { attrs: { value: "C2M2" } }, [_vm._v("C2M2")]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "gene-options-grid" },
            _vm._l(_vm.visibleExplorationCards, function (card) {
              return _c(
                "div",
                {
                  key: card["card label"],
                  staticClass: "gene-option-card",
                  class: {
                    "ai-analysis-card": card.category === "Gene Prioritization",
                  },
                },
                [
                  _c("div", { staticClass: "option-header" }, [
                    _c("h5", [_vm._v(_vm._s(card["card label"]))]),
                    _c(
                      "span",
                      {
                        staticClass: "option-badge",
                        class: {
                          "ai-badge": card.category === "Gene Prioritization",
                        },
                      },
                      [_vm._v(_vm._s(card.badge))]
                    ),
                  ]),
                  _c("div", { staticClass: "option-description" }, [
                    _c("p", [_vm._v(_vm._s(card["card description"]))]),
                  ]),
                  _c("div", { staticClass: "option-details" }, [
                    _c(
                      "ul",
                      _vm._l(card.details, function (detail, idx) {
                        return _c("li", {
                          key: `detail-${idx}`,
                          domProps: { innerHTML: _vm._s(detail) },
                        })
                      }),
                      0
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "option-actions" },
                    [
                      card.linkType === "c2m2_portal"
                        ? [
                            _vm.c2m2PortalLoading
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c2m2-portal-loading text-muted small",
                                  },
                                  [_vm._v("Loading portal links…")]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "c2m2-portal-link-buttons" },
                                  _vm._l(
                                    _vm.c2m2PortalLinks,
                                    function (portalLink, pIdx) {
                                      return _c(
                                        "a",
                                        {
                                          key: portalLink.url + "-" + pIdx,
                                          staticClass:
                                            "btn btn-primary option-btn c2m2-portal-btn",
                                          attrs: {
                                            href: portalLink.url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [_vm._v(_vm._s(portalLink.label))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                            _c("span", { staticClass: "option-note" }, [
                              _vm._v(_vm._s(_vm.getCardTip(card))),
                            ]),
                          ]
                        : [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary option-btn",
                                attrs: {
                                  disabled:
                                    !_vm.manualGenes.trim() ||
                                    (card["card label"] ===
                                      "Gene Relevance & Novelty Scoring" &&
                                      _vm.isGettingGeneNovelty) ||
                                    (card["card label"] ===
                                      "Genes to Hypothesis" &&
                                      _vm.isGeneratingHypothesis),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCardClick(card)
                                  },
                                },
                              },
                              [
                                (card["card label"] ===
                                  "Gene Relevance & Novelty Scoring" &&
                                  _vm.isGettingGeneNovelty) ||
                                (card["card label"] === "Genes to Hypothesis" &&
                                  _vm.isGeneratingHypothesis)
                                  ? _c("span", {
                                      staticClass: "loading-spinner-small",
                                    })
                                  : _vm._e(),
                                _vm._v(" " + _vm._s(card["open label"]) + " "),
                              ]
                            ),
                            _c("span", { staticClass: "option-note" }, [
                              _vm._v(_vm._s(_vm.getCardTip(card))),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
    _vm.showWelcomePopup
      ? _c("div", { staticClass: "welcome-popup-overlay" }, [
          _c("div", { staticClass: "welcome-popup" }, [
            _c("div", { staticClass: "welcome-popup-header" }, [
              _c("h3", [_vm._v("Welcome to CFDE-EXPLORE")]),
              _c(
                "button",
                {
                  staticClass: "close-btn",
                  on: { click: _vm.closeWelcomePopup },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "welcome-popup-content" }, [
              _c("p", [
                _vm._v(
                  "This tool helps you explore and analyze genes for your research. Here's what you need to get started:"
                ),
              ]),
              _c("div", { staticClass: "welcome-requirements" }, [
                _c(
                  "div",
                  {
                    staticClass: "requirement-item",
                    class: { found: _vm.urlHasGenes },
                  },
                  [
                    _c("div", { staticClass: "requirement-icon" }, [
                      _vm.urlHasGenes
                        ? _c("span", { staticClass: "check-icon" }, [
                            _vm._v("✓"),
                          ])
                        : _c("span", { staticClass: "missing-icon" }, [
                            _vm._v("○"),
                          ]),
                    ]),
                    _c("div", { staticClass: "requirement-content" }, [
                      _c("h4", [
                        _vm._v("Genes List (Required) "),
                        _vm.urlHasGenes
                          ? _c("span", { staticClass: "status-found" }, [
                              _vm._v("✓ Found in URL"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.urlHasGenes
                        ? _c("p", [
                            _vm._v(
                              "Great! We found genes in your URL parameters."
                            ),
                          ])
                        : _c("p", [
                            _vm._v(
                              "You need a list of genes to explore. You can:"
                            ),
                          ]),
                      !_vm.urlHasGenes
                        ? _c("ul", [
                            _c("li", [
                              _vm._v(
                                'Enter genes manually in the "Genes" field above'
                              ),
                            ]),
                            _c("li", [
                              _vm._v(
                                "Load genes from phenotype-gene set associations"
                              ),
                            ]),
                            _c("li", [
                              _vm._v(
                                "Use genes from URL parameters (if available)"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "requirement-item",
                    class: { found: _vm.urlHasHypothesis },
                  },
                  [
                    _c("div", { staticClass: "requirement-icon" }, [
                      _vm.urlHasHypothesis
                        ? _c("span", { staticClass: "check-icon" }, [
                            _vm._v("✓"),
                          ])
                        : _c("span", { staticClass: "missing-icon" }, [
                            _vm._v("○"),
                          ]),
                    ]),
                    _c("div", { staticClass: "requirement-content" }, [
                      _c("h4", [
                        _vm._v(
                          "Hypothesis (Optional - Required for Gene Prioritization) "
                        ),
                        _vm.urlHasHypothesis
                          ? _c("span", { staticClass: "status-found" }, [
                              _vm._v("✓ Found in URL"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.urlHasHypothesis
                        ? _c("p", [
                            _vm._v(
                              "Perfect! We found your hypothesis in the URL parameters."
                            ),
                          ])
                        : _c("p", { staticStyle: { margin: "0" } }, [
                            _vm._v("💡 "),
                            _c("strong", [_vm._v("Tip:")]),
                            _vm._v(
                              " Add a research hypothesis to use Gene Prioritization features (AI-powered scoring and ranking)."
                            ),
                          ]),
                      (_vm.urlHasGenes || _vm.manualGenes.trim()) &&
                      !_vm.urlHasHypothesis
                        ? _c("div", { staticStyle: { "margin-top": "12px" } }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-primary",
                                attrs: {
                                  disabled:
                                    _vm.isFetchingPhenotypes ||
                                    _vm.isGeneratingHypothesis,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.closeWelcomePopup()
                                    _vm.openPhenotypeSelection()
                                  },
                                },
                              },
                              [
                                _vm.isFetchingPhenotypes ||
                                _vm.isGeneratingHypothesis
                                  ? _c("span", {
                                      staticClass: "loading-spinner-small",
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isFetchingPhenotypes
                                        ? "Fetching..."
                                        : _vm.isGeneratingHypothesis
                                        ? `Generating... (${_vm.hypothesisGenerationElapsedTime})`
                                        : "Generate Hypothesis"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._m(5),
              ]),
              _c("div", { staticClass: "welcome-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.closeWelcomePopup },
                  },
                  [_vm._v("Got it, let's start!")]
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.showNoGenesPopup
      ? _c("div", { staticClass: "no-genes-popup-overlay" }, [
          _c("div", { staticClass: "no-genes-popup" }, [
            _c("div", { staticClass: "no-genes-popup-header" }, [
              _c("h3", [_vm._v("No Genes Found")]),
              _c(
                "button",
                {
                  staticClass: "close-btn",
                  on: { click: _vm.closeNoGenesPopup },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "no-genes-popup-content" }, [
              _vm._m(6),
              _c("p", [
                _vm._v(
                  "No genes were returned for the specified phenotype-gene set associations. The CFDE Knowledge Center is still working on generating the gene lists for these associations."
                ),
              ]),
              _vm._m(7),
              _vm._m(8),
              _c("div", { staticClass: "no-genes-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.closeNoGenesPopup },
                  },
                  [_vm._v("Got it")]
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.showPhenotypeDialog
      ? _c("div", { staticClass: "phenotype-dialog-overlay" }, [
          _c("div", { staticClass: "phenotype-dialog" }, [
            _c("div", { staticClass: "phenotype-dialog-header" }, [
              _c("h3", [_vm._v("Select Phenotypes for Hypothesis Generation")]),
              _c(
                "button",
                {
                  staticClass: "close-btn",
                  on: { click: _vm.closePhenotypeDialog },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "phenotype-dialog-content" }, [
              _vm.isFetchingPhenotypes
                ? _c("div", { staticClass: "loading-message" }, [
                    _c("span", { staticClass: "loading-spinner-small" }),
                    _c("span", [
                      _vm._v("Fetching phenotypes from Translator API..."),
                    ]),
                  ])
                : _vm.phenotypeData.length === 0
                ? _c("div", { staticClass: "no-data-message" }, [
                    _c("p", [
                      _vm._v("No phenotypes found for the provided genes."),
                    ]),
                  ])
                : _c("div", { staticClass: "phenotype-table-container" }, [
                    _c(
                      "div",
                      {
                        staticClass: "research-context-section",
                        staticStyle: { "margin-bottom": "20px" },
                      },
                      [
                        _vm._m(9),
                        _c("small", { staticClass: "format-suggestion" }, [
                          _vm._v(
                            'Provide additional context about your research goals or focus area (e.g., "The study is focused on identifying novel drug targets for non-alcoholic fatty liver disease.")'
                          ),
                        ]),
                        _c("div", { staticClass: "textarea-container" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.researchContext,
                                expression: "researchContext",
                              },
                            ],
                            staticClass: "hypothesis-textarea",
                            attrs: {
                              placeholder: "Enter your research context...",
                              rows: "2",
                            },
                            domProps: { value: _vm.researchContext },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.researchContext = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "phenotype-selection-info" }, [
                      _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.selectedPhenotypes.length)),
                        ]),
                        _vm._v(
                          " phenotype(s) selected (first 20 selected by default)"
                        ),
                      ]),
                      _c("div", { staticClass: "rows-per-page-selector" }, [
                        _c("label", { attrs: { for: "select-first-n" } }, [
                          _vm._v("Select phenotypes for hypothesis:"),
                        ]),
                        _c(
                          "select",
                          {
                            staticClass: "form-control form-control-sm",
                            staticStyle: {
                              display: "inline-block",
                              width: "auto",
                              "margin-left": "8px",
                            },
                            attrs: { id: "select-first-n" },
                            domProps: { value: _vm.phenotypeSelectionCount },
                            on: {
                              change: function ($event) {
                                return _vm.selectFirstNRows($event.target.value)
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: 5 } }, [
                              _vm._v("5"),
                            ]),
                            _c("option", { domProps: { value: 10 } }, [
                              _vm._v("10"),
                            ]),
                            _c("option", { domProps: { value: 20 } }, [
                              _vm._v("20"),
                            ]),
                            _c("option", { domProps: { value: 30 } }, [
                              _vm._v("30"),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-primary generate-hypothesis-dialog-btn",
                            staticStyle: { "margin-left": "12px" },
                            attrs: {
                              disabled:
                                _vm.selectedPhenotypes.length === 0 ||
                                _vm.isGeneratingHypothesis,
                            },
                            on: {
                              click:
                                _vm.generateHypothesisFromSelectedPhenotypes,
                            },
                          },
                          [
                            _vm.isGeneratingHypothesis
                              ? _c("span", {
                                  staticClass: "loading-spinner-small",
                                })
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.isGeneratingHypothesis
                                    ? `Generating... (${_vm.hypothesisGenerationElapsedTime})`
                                    : "Generate Hypothesis"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm.isGeneratingHypothesis && _vm.hypothesisGenerationStep
                      ? _c(
                          "div",
                          {
                            staticClass: "gene-sets-progress",
                            staticStyle: {
                              "margin-top": "20px",
                              padding: "8px 12px",
                              background: "#e3f2fd",
                              "border-left": "3px solid #1976d2",
                              "border-radius": "4px",
                              "font-size": "13px",
                              color: "#1976d2",
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "loading-spinner-small",
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.hypothesisGenerationStep) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "table-container" }, [
                      _vm.phenotypeData.length > 0
                        ? _c("table", { staticClass: "phenotype-table" }, [
                            _c("thead", [
                              _c(
                                "tr",
                                [
                                  _c("th", { staticStyle: { width: "40px" } }, [
                                    _c("input", {
                                      ref: "selectAllCheckbox",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: _vm.allPhenotypesSelected,
                                      },
                                      on: { change: _vm.toggleAllPhenotypes },
                                    }),
                                  ]),
                                  _vm._l(
                                    _vm.getOrderedColumnKeys(
                                      _vm.phenotypeData[0]
                                    ),
                                    function (key) {
                                      return _c(
                                        "th",
                                        {
                                          key: key,
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatColumnHeader(key)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.paginatedPhenotypeData,
                                function (phenotype, paginatedIndex) {
                                  return _c(
                                    "tr",
                                    {
                                      key: paginatedIndex,
                                      class: {
                                        "selected-row": _vm.isPhenotypeSelected(
                                          _vm.getFullIndex(paginatedIndex)
                                        ),
                                      },
                                    },
                                    [
                                      _c("td", [
                                        _c("input", {
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: _vm.isPhenotypeSelected(
                                              _vm.getFullIndex(paginatedIndex)
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.togglePhenotypeSelection(
                                                _vm.getFullIndex(paginatedIndex)
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._l(
                                        _vm.getOrderedColumnKeys(phenotype),
                                        function (key) {
                                          return _c("td", { key: key }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatCellValue(
                                                    phenotype[key]
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.phenotypeDialogTotalPages > 1
                      ? _c(
                          "div",
                          { staticClass: "phenotype-dialog-pagination" },
                          [
                            _c("div", { staticClass: "pagination-info" }, [
                              _vm._v(
                                " Showing " +
                                  _vm._s(
                                    (_vm.phenotypeDialogPage - 1) *
                                      _vm.phenotypeDialogItemsPerPage +
                                      1
                                  ) +
                                  " to " +
                                  _vm._s(
                                    Math.min(
                                      _vm.phenotypeDialogPage *
                                        _vm.phenotypeDialogItemsPerPage,
                                      _vm.phenotypeData.length
                                    )
                                  ) +
                                  " of " +
                                  _vm._s(_vm.phenotypeData.length) +
                                  " entries "
                              ),
                            ]),
                            _c("div", { staticClass: "pagination-controls" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn first-last-btn",
                                  attrs: {
                                    disabled: _vm.phenotypeDialogPage === 1,
                                    title: "First page",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.phenotypeDialogPage = 1
                                    },
                                  },
                                },
                                [_vm._v(" «« ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled: _vm.phenotypeDialogPage === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.phenotypeDialogPage--
                                    },
                                  },
                                },
                                [_vm._v(" Previous ")]
                              ),
                              _c(
                                "span",
                                { staticClass: "page-numbers" },
                                _vm._l(
                                  _vm.getVisiblePages(
                                    _vm.phenotypeDialogPage,
                                    _vm.phenotypeDialogTotalPages
                                  ),
                                  function (page) {
                                    return _c(
                                      "button",
                                      {
                                        key: page,
                                        class: [
                                          "page-btn",
                                          {
                                            active:
                                              page === _vm.phenotypeDialogPage,
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            _vm.phenotypeDialogPage = page
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(page) + " ")]
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn",
                                  attrs: {
                                    disabled:
                                      _vm.phenotypeDialogPage ===
                                      _vm.phenotypeDialogTotalPages,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.phenotypeDialogPage++
                                    },
                                  },
                                },
                                [_vm._v(" Next ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "pagination-btn first-last-btn",
                                  attrs: {
                                    disabled:
                                      _vm.phenotypeDialogPage ===
                                      _vm.phenotypeDialogTotalPages,
                                    title: "Last page",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.phenotypeDialogPage =
                                        _vm.phenotypeDialogTotalPages
                                    },
                                  },
                                },
                                [_vm._v(" »» ")]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "phenotype-dialog-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          on: { click: _vm.closePhenotypeDialog },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            disabled:
                              _vm.selectedPhenotypes.length === 0 ||
                              _vm.isGeneratingHypothesis,
                          },
                          on: {
                            click: _vm.generateHypothesisFromSelectedPhenotypes,
                          },
                        },
                        [
                          _vm.isGeneratingHypothesis
                            ? _c("span", {
                                staticClass: "loading-spinner-small",
                              })
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isGeneratingHypothesis
                                  ? `Generating... (${_vm.hypothesisGenerationElapsedTime})`
                                  : `Generate Hypothesis (${_vm.selectedPhenotypes.length})`
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.showScoreGenerationDialog
      ? _c("div", { staticClass: "phenotype-dialog-overlay" }, [
          _c("div", { staticClass: "phenotype-dialog" }, [
            _c("div", { staticClass: "phenotype-dialog-header" }, [
              _c("h3", [_vm._v("Gene Relevance & Novelty Scoring")]),
              _c(
                "button",
                {
                  staticClass: "close-btn",
                  on: { click: _vm.closeScoreGenerationDialog },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "phenotype-dialog-content" }, [
              _c(
                "div",
                {
                  staticClass: "research-context-section",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _vm._m(10),
                  _c("small", { staticClass: "format-suggestion" }, [
                    _vm._v(
                      'Provide additional context about your research goals or focus area (e.g., "The study is focused on identifying novel drug targets for non-alcoholic fatty liver disease.")'
                    ),
                  ]),
                  _c("div", { staticClass: "textarea-container" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.scoreGenerationResearchContext,
                          expression: "scoreGenerationResearchContext",
                        },
                      ],
                      staticClass: "hypothesis-textarea",
                      attrs: {
                        placeholder: "Enter your research context...",
                        rows: "3",
                      },
                      domProps: { value: _vm.scoreGenerationResearchContext },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.scoreGenerationResearchContext =
                            $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "design-info-section",
                  staticStyle: {
                    "margin-bottom": "20px",
                    padding: "15px",
                    background: "#f8f9fa",
                    "border-radius": "6px",
                  },
                },
                [
                  _vm._m(11),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        margin: "0",
                        color: "#666",
                        "font-size": "14px",
                        "line-height": "1.6",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.phenotypeSearch || "No hypothesis provided")
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "design-info-section",
                  staticStyle: {
                    "margin-bottom": "20px",
                    padding: "15px",
                    background: "#f8f9fa",
                    "border-radius": "6px",
                  },
                },
                [
                  _vm._m(12),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        margin: "0",
                        color: "#666",
                        "font-size": "14px",
                        "line-height": "1.6",
                      },
                    },
                    [_vm._v(_vm._s(_vm.manualGenes || "No genes provided"))]
                  ),
                ]
              ),
              _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "15px",
                      "flex-wrap": "wrap",
                    },
                  },
                  [
                    _vm.scoredGenes.length > 0 || _vm.geneData.length > 0
                      ? _c(
                          "div",
                          {
                            staticStyle: { color: "#666", "font-size": "13px" },
                          },
                          [
                            _vm.genesWithScoresCount > 0 ||
                            _vm.genesNeedingScoresCount > 0
                              ? _c(
                                  "span",
                                  [
                                    _vm.scoredGenes.length > 0
                                      ? [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.genesWithScoresCount)
                                            ),
                                          ]),
                                          _vm._v(" of "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getGeneCountFromInput()
                                              )
                                            ),
                                          ]),
                                          _vm._v(" genes scored "),
                                        ]
                                      : [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.genesWithScoresCount)
                                            ),
                                          ]),
                                          _vm._v(" of "),
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.geneData.length)),
                                          ]),
                                          _vm._v(" genes scored "),
                                        ],
                                    _vm.genesNeedingScoresCount > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#ff6600",
                                              "margin-left": "8px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.genesNeedingScoresCount
                                                ) +
                                                " remaining) "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm.genesNeedingScoresCount > 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "10px",
                          padding: "10px",
                          background: "#fff3cd",
                          "border-left": "3px solid #ffc107",
                          "border-radius": "4px",
                          "font-size": "12px",
                          color: "#856404",
                        },
                      },
                      [
                        _c("strong", [_vm._v("Tip:")]),
                        _vm._v(
                          " Scores are generated automatically as you navigate through pages. The first batch is generated when the dialog opens. "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm.isGettingGeneNovelty
                ? _c(
                    "div",
                    {
                      staticClass: "summary-loading-indicator",
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      _c("span", { staticClass: "loading-spinner-small" }),
                      _c("span", { staticClass: "loading-text" }, [
                        _vm._v(
                          "Generating gene to hypothesis relevance & innovation score... (" +
                            _vm._s(_vm.geneNoveltyElapsedTime) +
                            ")"
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.scoredGenes.length > 0 ||
              (_vm.geneData.length > 0 && !_vm.hasManualGenes)
                ? _c("div", { staticClass: "table-container" }, [
                    _vm.scoredGenes.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "tdl-legend",
                            staticStyle: {
                              "margin-bottom": "15px",
                              padding: "12px 15px",
                              background: "#f8f9fa",
                              border: "1px solid #dee2e6",
                              "border-radius": "6px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-bottom": "8px",
                                  "font-weight": "600",
                                  color: "#333",
                                  "font-size": "13px",
                                },
                              },
                              [
                                _vm._v(
                                  "Target Development Level (TDL) Classification:"
                                ),
                              ]
                            ),
                            _vm._m(13),
                          ]
                        )
                      : _vm._e(),
                    _vm.scoredGenes.length > 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-bottom": "10px",
                              display: "flex",
                              "align-items": "center",
                              gap: "8px",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "8px",
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.showOnlySelectedScoredGenes,
                                      expression: "showOnlySelectedScoredGenes",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "showOnlySelectedScoredGenes",
                                    disabled:
                                      _vm.selectedScoredGenes.length === 0,
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.showOnlySelectedScoredGenes
                                    )
                                      ? _vm._i(
                                          _vm.showOnlySelectedScoredGenes,
                                          null
                                        ) > -1
                                      : _vm.showOnlySelectedScoredGenes,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.showOnlySelectedScoredGenes,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.showOnlySelectedScoredGenes =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.showOnlySelectedScoredGenes =
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.showOnlySelectedScoredGenes = $$c
                                      }
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticStyle: {
                                      "font-size": "13px",
                                      color: "#333",
                                      cursor: "pointer",
                                    },
                                    attrs: {
                                      for: "showOnlySelectedScoredGenes",
                                    },
                                  },
                                  [_vm._v(" Show only selected ")]
                                ),
                                _vm.selectedScoredGenes.length > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "#666",
                                          "margin-left": "8px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " (" +
                                            _vm._s(
                                              _vm.selectedScoredGenes.length
                                            ) +
                                            " selected) "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-primary",
                                staticStyle: {
                                  padding: "6px 12px",
                                  "font-size": "13px",
                                },
                                attrs: {
                                  disabled:
                                    _vm.selectedScoredGenes.length === 0,
                                },
                                on: { click: _vm.downloadScoredGenes },
                              },
                              [_vm._v(" Download Selected Genes ")]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("table", { staticClass: "gene-data-table" }, [
                      _c("thead", [
                        _c("tr", [
                          _vm.scoredGenes.length > 0
                            ? _c(
                                "th",
                                {
                                  staticStyle: {
                                    width: "40px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "selectAllScoredGenesCheckbox",
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: _vm.allScoredGenesSelected(),
                                    },
                                    on: { change: _vm.toggleAllScoredGenes },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _c("th", [_vm._v("Gene")]),
                          _vm.scoredGenes.length > 0
                            ? _c("th", [_vm._v("Classification")])
                            : _vm._e(),
                          _c("th", [_vm._v("Relevance Score")]),
                          _c("th", [_vm._v("Novelty Score")]),
                          _c(
                            "th",
                            {
                              style: _vm.hasManualGenes
                                ? "width: 30%;"
                                : "width: 30%;",
                            },
                            [_vm._v("Reason")]
                          ),
                          _vm.scoredGenes.length > 0
                            ? _c("th", { staticStyle: { width: "30%" } }, [
                                _vm._v("Hypothesis Validation"),
                              ])
                            : _vm._e(),
                          _vm.scoredGenes.length > 0
                            ? _c("th", [_vm._v("IDG Novelty")])
                            : _vm._e(),
                          _vm.scoredGenes.length > 0
                            ? _c("th", [_vm._v("IDG Evidence")])
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "tbody",
                        [
                          _vm.scoredGenes.length > 0
                            ? [
                                _vm._l(
                                  _vm.paginatedScoredGenes,
                                  function (scoredGene) {
                                    return [
                                      _c(
                                        "tr",
                                        {
                                          key: `scored-${scoredGene.gene}`,
                                          class: {
                                            "selected-row":
                                              _vm.isScoredGeneSelected(
                                                scoredGene.gene
                                              ),
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "10px 8px",
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                                "text-align": "center",
                                              },
                                            },
                                            [
                                              _c("input", {
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked:
                                                    _vm.isScoredGeneSelected(
                                                      scoredGene.gene
                                                    ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.toggleScoredGeneSelection(
                                                      scoredGene.gene
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "font-weight": "600",
                                                color: "#333",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scoredGene.gene || "N/A")
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { staticStyle: { color: "#666" } },
                                            [
                                              scoredGene.classification &&
                                              scoredGene.classification !==
                                                "To be generated"
                                                ? _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scoredGene.classification
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _vm.isGettingGeneNovelty
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "loading-text",
                                                    },
                                                    [_vm._v("Loading...")]
                                                  )
                                                : _c("span", [
                                                    _vm._v("To be generated"),
                                                  ]),
                                            ]
                                          ),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "relevance-cell" },
                                              [
                                                scoredGene.relevance_score !==
                                                  undefined &&
                                                scoredGene.relevance_score !==
                                                  null &&
                                                scoredGene.relevance_score !==
                                                  "N/A" &&
                                                scoredGene.relevance_score !==
                                                  "To be generated"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "score-content",
                                                        class: {
                                                          "high-score":
                                                            typeof scoredGene.relevance_score ===
                                                              "number" &&
                                                            scoredGene.relevance_score >=
                                                              7,
                                                        },
                                                        staticStyle: {
                                                          "font-weight": "600",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scoredGene.relevance_score
                                                            ) +
                                                            _vm._s(
                                                              typeof scoredGene.relevance_score ===
                                                                "number"
                                                                ? "/10"
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.isGettingGeneNovelty
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "loading-text",
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c("span", [
                                                      _vm._v("To be generated"),
                                                    ]),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "novelty-cell" },
                                              [
                                                scoredGene.novelty_score !==
                                                  undefined &&
                                                scoredGene.novelty_score !==
                                                  null &&
                                                scoredGene.novelty_score !==
                                                  "N/A" &&
                                                scoredGene.novelty_score !==
                                                  "To be generated"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "score-content",
                                                        class: {
                                                          "high-score":
                                                            typeof scoredGene.novelty_score ===
                                                              "number" &&
                                                            scoredGene.novelty_score >=
                                                              7,
                                                        },
                                                        staticStyle: {
                                                          "font-weight": "600",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scoredGene.novelty_score
                                                            ) +
                                                            _vm._s(
                                                              typeof scoredGene.novelty_score ===
                                                                "number"
                                                                ? "/10"
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.isGettingGeneNovelty
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "loading-text",
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c("span", [
                                                      _vm._v("To be generated"),
                                                    ]),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "reason-cell" },
                                              [
                                                scoredGene.reason &&
                                                scoredGene.reason !==
                                                  "To be generated"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reason-content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scoredGene.reason
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.isGettingGeneNovelty
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "loading-text",
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c("span", [
                                                      _vm._v("To be generated"),
                                                    ]),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "reason-cell" },
                                              [
                                                scoredGene.hypothesis_validation &&
                                                scoredGene.hypothesis_validation !==
                                                  "To be generated"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reason-content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scoredGene.hypothesis_validation
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.isGettingGeneNovelty
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "loading-text",
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c("span", [
                                                      _vm._v("To be generated"),
                                                    ]),
                                              ]
                                            ),
                                          ]),
                                          _c(
                                            "td",
                                            [
                                              scoredGene.idg_tdl
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: _vm.getTDLClass(
                                                          scoredGene.idg_tdl
                                                        ),
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          padding: "4px 10px",
                                                          "border-radius":
                                                            "4px",
                                                          "font-weight": "600",
                                                          "font-size": "11px",
                                                          color: "white",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scoredGene.idg_tdl
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : scoredGene.idg_fetched
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [_vm._v("N/A")]
                                                  )
                                                : scoredGene.relevance_score !==
                                                  "To be generated"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [_vm._v("Loading...")]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [_vm._v("To be generated")]
                                                  ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                padding: "10px 8px",
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                                "text-align": "center",
                                              },
                                            },
                                            [
                                              scoredGene.idg_fullData
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "idg-view-button",
                                                      class: {
                                                        active:
                                                          _vm.expandedScoredGenesIDG.includes(
                                                            scoredGene.gene
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleScoredGeneIDGEvidenceView(
                                                            scoredGene.gene
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.expandedScoredGenesIDG.includes(
                                                              scoredGene.gene
                                                            )
                                                              ? "Hide"
                                                              : "View"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : scoredGene.idg_fetched ===
                                                    false &&
                                                  scoredGene.relevance_score !==
                                                    "To be generated"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-style": "italic",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("Loading...")]
                                                  )
                                                : scoredGene.idg_fetched ===
                                                  true
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("N/A")]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.expandedScoredGenesIDG.includes(
                                        scoredGene.gene
                                      ) && scoredGene.idg_fullData
                                        ? _c(
                                            "tr",
                                            {
                                              key: `idg-evidence-${scoredGene.gene}`,
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    padding: "0",
                                                    "border-bottom":
                                                      "1px solid #dee2e6",
                                                  },
                                                  attrs: {
                                                    colspan:
                                                      _vm.scoredGenes.length > 0
                                                        ? 9
                                                        : 6,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "idg-evidence-subtable",
                                                    },
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "idg-evidence-table",
                                                        },
                                                        [
                                                          _vm._m(14, true),
                                                          _c("tbody", [
                                                            _c("tr", [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scoredGene
                                                                      .idg_fullData
                                                                      .sym ||
                                                                      "N/A"
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scoredGene
                                                                      .idg_fullData
                                                                      .name ||
                                                                      "N/A"
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scoredGene
                                                                      .idg_fullData
                                                                      .fam ||
                                                                      "N/A"
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                scoredGene
                                                                  .idg_fullData
                                                                  .tdl
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        class:
                                                                          _vm.getTDLClass(
                                                                            scoredGene
                                                                              .idg_fullData
                                                                              .tdl
                                                                          ),
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "inline-block",
                                                                            padding:
                                                                              "4px 10px",
                                                                            "border-radius":
                                                                              "4px",
                                                                            "font-weight":
                                                                              "600",
                                                                            "font-size":
                                                                              "11px",
                                                                            color:
                                                                              "white",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              scoredGene
                                                                                .idg_fullData
                                                                                .tdl
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "N/A"
                                                                      ),
                                                                    ]),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scoredGene
                                                                      .idg_fullData
                                                                      .description ||
                                                                      "N/A"
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scoredGene
                                                                      .idg_fullData
                                                                      .novelty ||
                                                                      "N/A"
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                scoredGene
                                                                  .idg_fullData
                                                                  .sym
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#1976d2",
                                                                            "text-decoration":
                                                                              "none",
                                                                          },
                                                                        attrs: {
                                                                          href: `https://pharos.nih.gov/targets/${scoredGene.idg_fullData.sym}`,
                                                                          target:
                                                                            "_blank",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Open "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "N/A"
                                                                      ),
                                                                    ]),
                                                              ]),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ]
                            : _vm._l(_vm.allTableRows, function (row) {
                                return _c(
                                  "tr",
                                  { key: row.key },
                                  [
                                    row.type === "gene"
                                      ? [
                                          _c("td", [
                                            _vm._v(_vm._s(row.item.gene)),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "relevance-cell" },
                                              [
                                                _vm.getRelevance(row.item.gene)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "score-content",
                                                        class: {
                                                          "high-score":
                                                            _vm.getRelevance(
                                                              row.item.gene
                                                            ).score >= 7,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "score-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getRelevanceScore(
                                                                  row.item.gene
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.isGettingGeneNovelty &&
                                                    !_vm.getRelevance(
                                                      row.item.gene
                                                    )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "loading-text",
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c("span", [_vm._v("TBD")]),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "novelty-cell" },
                                              [
                                                _vm.getNovelty(row.item.gene)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "score-content",
                                                        class: {
                                                          "high-score":
                                                            _vm.getNovelty(
                                                              row.item.gene
                                                            ).score >= 7,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "score-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getNoveltyScore(
                                                                  row.item.gene
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.isGettingGeneNovelty &&
                                                    !_vm.getRelevance(
                                                      row.item.gene
                                                    )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "loading-text",
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c("span", [_vm._v("TBD")]),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "reason-cell" },
                                              [
                                                _vm.getNovelty(row.item.gene)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reason-content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.getNovelty(
                                                                row.item.gene
                                                              ).context
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.isGettingGeneNovelty &&
                                                    !_vm.getRelevance(
                                                      row.item.gene
                                                    )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "loading-text",
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c("span", [_vm._v("TBD")]),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      : row.type === "evidence"
                                      ? [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                colspan: _vm.hasManualGenes
                                                  ? 4
                                                  : 5,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "evidence-subtable",
                                                },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      staticClass:
                                                        "evidence-table",
                                                    },
                                                    [
                                                      _vm._m(15, true),
                                                      _c(
                                                        "tbody",
                                                        _vm._l(
                                                          _vm.getEvidenceData(
                                                            row.item
                                                          ),
                                                          function (
                                                            evidence,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "tr",
                                                              {
                                                                key: `${row.item.gene}-evidence-${index}`,
                                                              },
                                                              [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getPhenotypeDisplayNames(
                                                                        evidence.phenotype
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      evidence.gene_set
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      evidence.combined
                                                                        ? evidence.combined.toFixed(
                                                                            2
                                                                          )
                                                                        : "N/A"
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      evidence.log_bf
                                                                        ? evidence.log_bf.toFixed(
                                                                            2
                                                                          )
                                                                        : "N/A"
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      evidence.prior
                                                                        ? evidence.prior.toFixed(
                                                                            2
                                                                          )
                                                                        : "N/A"
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "pagination-container" }, [
                      _c(
                        "div",
                        { staticClass: "pagination-info" },
                        [
                          _vm.scoredGenes.length > 0
                            ? [
                                _vm.showOnlySelectedScoredGenes &&
                                _vm.selectedScoredGenes.length > 0
                                  ? [
                                      _vm._v(
                                        " Showing " +
                                          _vm._s(
                                            (_vm.currentPage - 1) *
                                              _vm.itemsPerPage +
                                              1
                                          ) +
                                          " to " +
                                          _vm._s(
                                            Math.min(
                                              _vm.currentPage *
                                                _vm.itemsPerPage,
                                              _vm.selectedScoredGenes.length
                                            )
                                          ) +
                                          " of " +
                                          _vm._s(
                                            _vm.selectedScoredGenes.length
                                          ) +
                                          " selected entries "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        " Showing " +
                                          _vm._s(
                                            (_vm.currentPage - 1) *
                                              _vm.itemsPerPage +
                                              1
                                          ) +
                                          " to " +
                                          _vm._s(
                                            Math.min(
                                              _vm.currentPage *
                                                _vm.itemsPerPage,
                                              _vm.scoredGenes.length
                                            )
                                          ) +
                                          " of " +
                                          _vm._s(_vm.scoredGenes.length) +
                                          " entries "
                                      ),
                                    ],
                              ]
                            : [
                                _vm._v(
                                  " Showing " +
                                    _vm._s(
                                      (_vm.currentPage - 1) * _vm.itemsPerPage +
                                        1
                                    ) +
                                    " to " +
                                    _vm._s(
                                      Math.min(
                                        _vm.currentPage * _vm.itemsPerPage,
                                        _vm.filteredGenes.length
                                      )
                                    ) +
                                    " of " +
                                    _vm._s(_vm.filteredGenes.length) +
                                    " entries "
                                ),
                              ],
                        ],
                        2
                      ),
                      _c("div", { staticClass: "pagination-controls" }, [
                        _c(
                          "button",
                          {
                            staticClass: "pagination-btn first-last-btn",
                            attrs: {
                              disabled: _vm.currentPage === 1,
                              title: "First page",
                            },
                            on: { click: _vm.goToFirstPage },
                          },
                          [_vm._v(" «« ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "pagination-btn",
                            attrs: { disabled: _vm.currentPage === 1 },
                            on: { click: _vm.previousPage },
                          },
                          [_vm._v(" Previous ")]
                        ),
                        _c(
                          "span",
                          { staticClass: "page-numbers" },
                          _vm._l(_vm.visiblePages, function (page) {
                            return _c(
                              "button",
                              {
                                key: page,
                                class: [
                                  "page-btn",
                                  { active: page === _vm.currentPage },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.goToPage(page)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(page) + " ")]
                            )
                          }),
                          0
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "pagination-btn",
                            attrs: {
                              disabled: _vm.currentPage === _vm.totalPages,
                            },
                            on: { click: _vm.nextPage },
                          },
                          [_vm._v(" Next ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "pagination-btn first-last-btn",
                            attrs: {
                              disabled: _vm.currentPage === _vm.totalPages,
                              title: "Last page",
                            },
                            on: { click: _vm.goToLastPage },
                          },
                          [_vm._v(" »» ")]
                        ),
                      ]),
                    ]),
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "40px 20px",
                        "text-align": "center",
                        color: "#666",
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(
                          'No genes in table. Click "Generate Scores" to add genes and generate scores.'
                        ),
                      ]),
                    ]
                  ),
            ]),
            _c("div", { staticClass: "phenotype-dialog-actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  on: { click: _vm.closeScoreGenerationDialog },
                },
                [_vm._v("Close")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.showDesignToolDialog
      ? _c("div", { staticClass: "phenotype-dialog-overlay" }, [
          _c("div", { staticClass: "phenotype-dialog" }, [
            _c("div", { staticClass: "phenotype-dialog-header" }, [
              _c("h3", [_vm._v("Candidate Gene Selection & Ranking")]),
              _c(
                "button",
                {
                  staticClass: "close-btn",
                  on: { click: _vm.closeDesignToolDialog },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "phenotype-dialog-content" }, [
              _c(
                "div",
                {
                  staticClass: "research-context-section",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _vm._m(16),
                  _c("small", { staticClass: "format-suggestion" }, [
                    _vm._v(
                      'Provide additional context about your research goals or focus area (e.g., "The study is focused on identifying novel drug targets for non-alcoholic fatty liver disease.")'
                    ),
                  ]),
                  _c("div", { staticClass: "textarea-container" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.designToolResearchContext,
                          expression: "designToolResearchContext",
                        },
                      ],
                      staticClass: "hypothesis-textarea",
                      attrs: {
                        placeholder: "Enter your research context...",
                        rows: "3",
                      },
                      domProps: { value: _vm.designToolResearchContext },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.designToolResearchContext = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "design-info-section",
                  staticStyle: {
                    "margin-bottom": "20px",
                    padding: "15px",
                    background: "#f8f9fa",
                    "border-radius": "6px",
                  },
                },
                [
                  _vm._m(17),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        margin: "0",
                        color: "#666",
                        "font-size": "14px",
                        "line-height": "1.6",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.phenotypeSearch || "No hypothesis provided")
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "design-info-section",
                  staticStyle: {
                    "margin-bottom": "20px",
                    padding: "15px",
                    background: "#f8f9fa",
                    "border-radius": "6px",
                  },
                },
                [
                  _vm._m(18),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        margin: "0",
                        color: "#666",
                        "font-size": "14px",
                        "line-height": "1.6",
                      },
                    },
                    [_vm._v(_vm._s(_vm.manualGenes || "No genes provided"))]
                  ),
                ]
              ),
              _vm.isRankingGenes
                ? _c(
                    "div",
                    {
                      staticClass: "gene-sets-progress",
                      staticStyle: {
                        "margin-bottom": "20px",
                        padding: "12px 16px",
                        background: "#e3f2fd",
                        "border-left": "3px solid #1976d2",
                        "border-radius": "4px",
                        "font-size": "13px",
                        color: "#1976d2",
                      },
                    },
                    [
                      _c("span", { staticClass: "loading-spinner-small" }),
                      _vm.geneRankingStep
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.geneRankingStep) +
                                " (" +
                                _vm._s(_vm.geneRankingElapsedTime) +
                                ")"
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              "Ranking candidate genes... (" +
                                _vm._s(_vm.geneRankingElapsedTime) +
                                ")"
                            ),
                          ]),
                    ]
                  )
                : _vm._e(),
              _vm.candidateGenes.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "candidate-genes-section",
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-header",
                          staticStyle: { "margin-bottom": "15px" },
                        },
                        [
                          _c("h4", [
                            _vm._v(
                              "Candidate Genes Selected (" +
                                _vm._s(_vm.selectedCandidateGenes.length) +
                                " of " +
                                _vm._s(_vm.candidateGenes.length) +
                                " selected)"
                            ),
                          ]),
                        ]
                      ),
                      _vm._m(19),
                      _vm.candidateGenes.length > 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "justify-content": "flex-end",
                              },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-primary",
                                  staticStyle: {
                                    padding: "6px 12px",
                                    "font-size": "13px",
                                  },
                                  attrs: {
                                    disabled:
                                      _vm.selectedCandidateGenes.length === 0,
                                  },
                                  on: { click: _vm.downloadCandidateGenes },
                                },
                                [_vm._v(" Download Selected Genes ")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "table-container" }, [
                        _c(
                          "table",
                          {
                            staticClass: "candidate-genes-table",
                            staticStyle: {
                              width: "100%",
                              "border-collapse": "collapse",
                              background: "white",
                              border: "1px solid #ddd",
                              "font-size": "13px",
                            },
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      width: "40px",
                                      padding: "10px 8px",
                                      "text-align": "left",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                    },
                                  },
                                  [
                                    _c("input", {
                                      ref: "selectAllCandidateGenesCheckbox",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.allCandidateGenesSelected(),
                                      },
                                      on: {
                                        change: _vm.toggleAllCandidateGenes,
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "left",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                    },
                                  },
                                  [_vm._v("Gene")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "left",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                    },
                                  },
                                  [_vm._v("Classification")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "center",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                    },
                                  },
                                  [_vm._v("Relevance Score")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "center",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                    },
                                  },
                                  [_vm._v("Novelty Score")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "left",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                      width: "30%",
                                    },
                                  },
                                  [_vm._v("Reason")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "left",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                      width: "30%",
                                    },
                                  },
                                  [_vm._v("Hypothesis Validation")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "center",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                    },
                                  },
                                  [_vm._v("IDG Novelty")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      padding: "10px 8px",
                                      "text-align": "center",
                                      background: "#f8f9fa",
                                      "border-bottom": "2px solid #dee2e6",
                                      "font-weight": "600",
                                    },
                                  },
                                  [_vm._v("IDG Evidence")]
                                ),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.candidateGenesTableRows,
                                function (row) {
                                  return _c(
                                    "tr",
                                    {
                                      key: row.key,
                                      class: {
                                        "selected-row":
                                          row.type === "candidate" &&
                                          _vm.isCandidateGeneSelected(
                                            row.index
                                          ),
                                      },
                                    },
                                    [
                                      row.type === "candidate"
                                        ? [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked:
                                                      _vm.isCandidateGeneSelected(
                                                        row.index
                                                      ),
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.toggleCandidateGeneSelection(
                                                        row.index
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  "font-weight": "600",
                                                  color: "#333",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.candidate.gene || "N/A"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  color: "#666",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.candidate
                                                      .classification || "N/A"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  "text-align": "center",
                                                  color: "#666",
                                                },
                                              },
                                              [
                                                row.candidate
                                                  .relevance_score !==
                                                  undefined &&
                                                row.candidate
                                                  .relevance_score !== null &&
                                                row.candidate
                                                  .relevance_score !== "N/A"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        class: {
                                                          "high-score":
                                                            typeof row.candidate
                                                              .relevance_score ===
                                                              "number" &&
                                                            row.candidate
                                                              .relevance_score >=
                                                              7,
                                                        },
                                                        staticStyle: {
                                                          "font-weight": "600",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              row.candidate
                                                                .relevance_score
                                                            ) +
                                                            _vm._s(
                                                              typeof row
                                                                .candidate
                                                                .relevance_score ===
                                                                "number"
                                                                ? "/10"
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("N/A")]),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  "text-align": "center",
                                                  color: "#666",
                                                },
                                              },
                                              [
                                                row.candidate.novelty_score !==
                                                  undefined &&
                                                row.candidate.novelty_score !==
                                                  null &&
                                                row.candidate.novelty_score !==
                                                  "N/A"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        class: {
                                                          "high-score":
                                                            typeof row.candidate
                                                              .novelty_score ===
                                                              "number" &&
                                                            row.candidate
                                                              .novelty_score >=
                                                              7,
                                                        },
                                                        staticStyle: {
                                                          "font-weight": "600",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              row.candidate
                                                                .novelty_score
                                                            ) +
                                                            _vm._s(
                                                              typeof row
                                                                .candidate
                                                                .novelty_score ===
                                                                "number"
                                                                ? "/10"
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("N/A")]),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  color: "#666",
                                                  "line-height": "1.5",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.candidate.reason ||
                                                      "N/A"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  color: "#666",
                                                  "line-height": "1.5",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    row.candidate
                                                      .hypothesis_validation ||
                                                      "N/A"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  "text-align": "center",
                                                  color: "#666",
                                                },
                                              },
                                              [
                                                row.candidate.idg_tdl
                                                  ? [
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            _vm.getTDLClass(
                                                              row.candidate
                                                                .idg_tdl
                                                            ),
                                                          staticStyle: {
                                                            display:
                                                              "inline-block",
                                                            padding: "4px 10px",
                                                            "border-radius":
                                                              "4px",
                                                            "font-weight":
                                                              "600",
                                                            "font-size": "11px",
                                                            color: "white",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.candidate
                                                                .idg_tdl
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : row.candidate.idg_tdl ===
                                                    undefined
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#999",
                                                          "font-style":
                                                            "italic",
                                                        },
                                                      },
                                                      [_vm._v(" Loading... ")]
                                                    )
                                                  : _c("span", [_vm._v("N/A")]),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "10px 8px",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                row.candidate.idg_fullData
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "idg-view-button",
                                                        class: {
                                                          active:
                                                            _vm.expandedIDGGenes.includes(
                                                              row.candidate.gene
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleIDGEvidenceView(
                                                              row.candidate.gene
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.expandedIDGGenes.includes(
                                                                row.candidate
                                                                  .gene
                                                              )
                                                                ? "Hide"
                                                                : "View"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : row.candidate
                                                      .idg_fullData ===
                                                    undefined
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#999",
                                                          "font-style":
                                                            "italic",
                                                          "font-size": "12px",
                                                        },
                                                      },
                                                      [_vm._v("Loading...")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#999",
                                                          "font-size": "12px",
                                                        },
                                                      },
                                                      [_vm._v("N/A")]
                                                    ),
                                              ]
                                            ),
                                          ]
                                        : row.type === "idg-evidence"
                                        ? [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  padding: "0",
                                                  "border-bottom":
                                                    "1px solid #dee2e6",
                                                },
                                                attrs: { colspan: 9 },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "idg-evidence-subtable",
                                                  },
                                                  [
                                                    _c(
                                                      "table",
                                                      {
                                                        staticClass:
                                                          "idg-evidence-table",
                                                      },
                                                      [
                                                        _vm._m(20, true),
                                                        _c("tbody", [
                                                          _c("tr", [
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.candidate
                                                                    .idg_fullData
                                                                    .sym ||
                                                                    "N/A"
                                                                )
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.candidate
                                                                    .idg_fullData
                                                                    .name ||
                                                                    "N/A"
                                                                )
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.candidate
                                                                    .idg_fullData
                                                                    .fam ||
                                                                    "N/A"
                                                                )
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              row.candidate
                                                                .idg_fullData
                                                                .tdl
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      class:
                                                                        _vm.getTDLClass(
                                                                          row
                                                                            .candidate
                                                                            .idg_fullData
                                                                            .tdl
                                                                        ),
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "inline-block",
                                                                          padding:
                                                                            "4px 10px",
                                                                          "border-radius":
                                                                            "4px",
                                                                          "font-weight":
                                                                            "600",
                                                                          "font-size":
                                                                            "11px",
                                                                          color:
                                                                            "white",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            row
                                                                              .candidate
                                                                              .idg_fullData
                                                                              .tdl
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "N/A"
                                                                    ),
                                                                  ]),
                                                            ]),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  "max-width":
                                                                    "400px",
                                                                  "word-wrap":
                                                                    "break-word",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row
                                                                      .candidate
                                                                      .idg_fullData
                                                                      .description ||
                                                                      "N/A"
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.candidate
                                                                    .idg_fullData
                                                                    .novelty !==
                                                                    null &&
                                                                    row
                                                                      .candidate
                                                                      .idg_fullData
                                                                      .novelty !==
                                                                      undefined
                                                                    ? row
                                                                        .candidate
                                                                        .idg_fullData
                                                                        .novelty
                                                                    : "N/A"
                                                                )
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              row.candidate
                                                                .idg_fullData
                                                                .sym
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#FF6600",
                                                                          "text-decoration":
                                                                            "none",
                                                                          "font-weight":
                                                                            "600",
                                                                        },
                                                                      attrs: {
                                                                        href: `https://pharos.nih.gov/targets/${row.candidate.idg_fullData.sym}`,
                                                                        target:
                                                                          "_blank",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Open "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "N/A"
                                                                    ),
                                                                  ]),
                                                            ]),
                                                          ]),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "small",
                        {
                          staticStyle: {
                            color: "#666",
                            "font-size": "12px",
                            display: "block",
                            "margin-top": "8px",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.candidateGenes.length) +
                              " candidate gene(s) selected from " +
                              _vm._s(_vm.getGeneCount()) +
                              " total genes"
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "phenotype-dialog-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    on: { click: _vm.closeDesignToolDialog },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm.candidateGenes.length === 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { disabled: _vm.isRankingGenes },
                        on: { click: _vm.prepareForDesign },
                      },
                      [
                        _vm.isRankingGenes
                          ? _c("span", { staticClass: "loading-spinner-small" })
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isRankingGenes
                                ? `Ranking genes... (${_vm.geneRankingElapsedTime})`
                                : "Rank Genes"
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          disabled: _vm.selectedCandidateGenes.length === 0,
                        },
                        on: { click: _vm.openDesignToolWithSelectedGenes },
                      },
                      [
                        _vm._v(
                          " Open CFDE DESIGN (" +
                            _vm._s(_vm.selectedCandidateGenes.length) +
                            " gene" +
                            _vm._s(
                              _vm.selectedCandidateGenes.length !== 1 ? "s" : ""
                            ) +
                            ") "
                        ),
                      ]
                    ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "url-choice-header" }, [
      _c("h3", [_vm._v("Choose Gene Source")]),
      _c("p", [
        _vm._v(
          "Both associations and genes parameters were found in the URL. Please choose which gene source you'd like to use for validation:"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "url-choice-title" }, [
      _c("h4", [_vm._v("Genes from Associations")]),
      _c("p", [_vm._v("Fetch genes from phenotype-gene set associations")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "url-choice-title" }, [
      _c("h4", [_vm._v("Genes from URL Parameter")]),
      _c("p", [_vm._v("Use the specific genes provided in the URL")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Phenotype Gene set Associations")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Genes")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "requirement-item options" }, [
      _c("div", { staticClass: "requirement-icon" }, [
        _c("span", { staticClass: "info-icon" }, [_vm._v("ℹ")]),
      ]),
      _c("div", { staticClass: "requirement-content" }, [
        _c("h4", [_vm._v("Exploration Options")]),
        _c("p", [
          _vm._v("Once you have genes, you can explore them in three ways:"),
        ]),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("Gene Prioritization:")]),
            _vm._v(
              " AI-powered scoring and ranking to narrow down your gene list (requires hypothesis)"
            ),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Expression Analysis:")]),
            _vm._v(
              " Explore where and when genes are active across tissues and conditions"
            ),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Discovery & Enrichment:")]),
            _vm._v(
              " Find connections and patterns across multiple CFDE databases"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "no-genes-icon" }, [
      _c("span", { staticClass: "warning-icon" }, [_vm._v("⚠️")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("What you can do:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          'Enter genes manually in the "Genes" field above to continue exploring'
        ),
      ]),
      _c("li", [
        _vm._v("Try again later once the gene generation is complete"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Research Context (Optional)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [
        _vm._v("Research Context "),
        _c(
          "span",
          { staticStyle: { color: "#666", "font-weight": "normal" } },
          [_vm._v("(Optional)")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Hypothesis")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Genes")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-wrap": "nowrap",
          gap: "12px 20px",
          "font-size": "12px",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "flex-start",
              gap: "6px",
              flex: "1",
              "min-width": "0",
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "tdl-badge tclin",
                staticStyle: {
                  display: "inline-block",
                  padding: "4px 10px",
                  "border-radius": "4px",
                  "font-weight": "600",
                  "font-size": "11px",
                  color: "white",
                  background: "#007bff",
                  "flex-shrink": "0",
                },
              },
              [_vm._v("Tclin")]
            ),
            _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
              _vm._v("Targets of approved drugs"),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "flex-start",
              gap: "6px",
              flex: "1",
              "min-width": "0",
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "tdl-badge tchem",
                staticStyle: {
                  display: "inline-block",
                  padding: "4px 10px",
                  "border-radius": "4px",
                  "font-weight": "600",
                  "font-size": "11px",
                  color: "white",
                  background: "#17a2b8",
                  "flex-shrink": "0",
                },
              },
              [_vm._v("Tchem")]
            ),
            _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
              _vm._v("Bind small molecules with high potency"),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "flex-start",
              gap: "6px",
              flex: "1",
              "min-width": "0",
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "tdl-badge tbio",
                staticStyle: {
                  display: "inline-block",
                  padding: "4px 10px",
                  "border-radius": "4px",
                  "font-weight": "600",
                  "font-size": "11px",
                  color: "white",
                  background: "#fd7e14",
                  "flex-shrink": "0",
                },
              },
              [_vm._v("Tbio")]
            ),
            _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
              _vm._v("Linked to biological processes relevant to disease"),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "flex-start",
              gap: "6px",
              flex: "1",
              "min-width": "0",
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "tdl-badge tdark",
                staticStyle: {
                  display: "inline-block",
                  padding: "4px 10px",
                  "border-radius": "4px",
                  "font-weight": "600",
                  "font-size": "11px",
                  color: "white",
                  background: "#dc3545",
                  "flex-shrink": "0",
                },
              },
              [_vm._v("Tdark")]
            ),
            _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
              _vm._v("No clinical, chemical, or biological links to disease"),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Gene")]),
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Family")]),
        _c("th", [_vm._v("TDL")]),
        _c("th", [_vm._v("Description")]),
        _c("th", [_vm._v("Novelty")]),
        _c("th", [_vm._v("Visit Pharos")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Phenotype")]),
        _c("th", [_vm._v("Gene Set")]),
        _c("th", [_vm._v("Combined Genetic Support")]),
        _c("th", [_vm._v("Direct Genetic Support")]),
        _c("th", [_vm._v("Indirect Genetic Support")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [
        _vm._v("Research Context "),
        _c(
          "span",
          { staticStyle: { color: "#666", "font-weight": "normal" } },
          [_vm._v("(Optional)")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Hypothesis")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Genes")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "tdl-legend",
        staticStyle: {
          "margin-bottom": "15px",
          padding: "12px 15px",
          background: "#f8f9fa",
          border: "1px solid #dee2e6",
          "border-radius": "6px",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              "margin-bottom": "8px",
              "font-weight": "600",
              color: "#333",
              "font-size": "13px",
            },
          },
          [_vm._v("Target Development Level (TDL) Classification:")]
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-wrap": "nowrap",
              gap: "12px 20px",
              "font-size": "12px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tclin",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#007bff",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tclin")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Targets of approved drugs"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tchem",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#17a2b8",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tchem")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Bind small molecules with high potency"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tbio",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#fd7e14",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tbio")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v("Linked to biological processes relevant to disease"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "flex-start",
                  gap: "6px",
                  flex: "1",
                  "min-width": "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tdl-badge tdark",
                    staticStyle: {
                      display: "inline-block",
                      padding: "4px 10px",
                      "border-radius": "4px",
                      "font-weight": "600",
                      "font-size": "11px",
                      color: "white",
                      background: "#dc3545",
                      "flex-shrink": "0",
                    },
                  },
                  [_vm._v("Tdark")]
                ),
                _c("span", { staticStyle: { color: "#666", flex: "1" } }, [
                  _vm._v(
                    "No clinical, chemical, or biological links to disease"
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Gene")]),
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Family")]),
        _c("th", [_vm._v("TDL")]),
        _c("th", [_vm._v("Description")]),
        _c("th", [_vm._v("Novelty")]),
        _c("th", [_vm._v("Visit Pharos")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }